module.exports = __webpack_public_path__ + "img/11.f198e1ff.png";